
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/translation'

export default defineComponent({
  props: {
    entries: { type: Array, required: false, default: () => [] },
    sliderOptions: { type: Object, required: false, default: () => {} },
  },
  setup() {
    return {
      ...setupTranslationPrefixer('matrix-project-spotlight'),
    }
  },
  data() {
    return {
      tinySliderOptions: {
        arrowKeys: true,
        autoWidth: false,
        controls: false,
        edgePadding: 16,
        gutter: 10,
        items: 2,
        lazyload: true,
        loop: false,
        mouseDrag: true,
        preventScrollOnTouch: 'auto',
        fixedWidth: 285,
        responsive: {
          640: {
            edgePadding: 50,
            fixedWidth: 485,
          },
          1024: {
            edgePadding: 80,
          },
        },
        speed: 400,
        swipeAngle: false,
        ...this.sliderOptions,
      },
      sliderProgress: ref(0),
    }
  },
  mounted() {
    setTimeout(() => {
      this.updateSliderProgress()
    }, 0)
  },
  methods: {
    sliderNext() {
      this.$refs.tinySlider.goTo('next')
      this.updateSliderProgress()
    },
    sliderPrev() {
      this.$refs.tinySlider.goTo('prev')
      this.updateSliderProgress()
    },
    updateSliderProgress() {
      const { index, slideCount, slideItems } = this.$refs.tinySlider.slider.getInfo()
      const windowWidth = window.innerWidth
      const slideWidth = slideItems[0].offsetWidth
      let totalSlideWidth = slideWidth * slideCount
      let slidesToEnd = 0

      while (totalSlideWidth > windowWidth) {
        slidesToEnd++
        totalSlideWidth = totalSlideWidth - slideWidth
      }

      this.sliderProgress = Math.min((index / slidesToEnd) * 100, 100)
    },
  },
})
